import { render, staticRenderFns } from "./tab-description.vue?vue&type=template&id=73ad1886&scoped=true"
import script from "./tab-description.vue?vue&type=script&lang=ts"
export * from "./tab-description.vue?vue&type=script&lang=ts"
import style0 from "./tab-description.vue?vue&type=style&index=0&id=73ad1886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ad1886",
  null
  
)

export default component.exports